import { Box } from '@material-ui/core'
import { TextField } from '@mui/material'
import RegularButton from 'components/CustomButtons/Button'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { postPipeConditionUnit } from 'redux/actions/unitsSection/unitsAction'
import { putPipeConditionUnit } from 'redux/actions/unitsSection/unitsAction'

export const AddPipeCondition = (props) => {
  const {
    data,
    onClose
  } = props
  const pipeCondition = data?.pipeConditions ? data?.pipeConditions[0] : {}
  const dispatch = useDispatch()
  const [percentage, setPercentage] = useState({})
  
  const handlePercentage = ({target}) => {
    setPercentage(target?.value)
  }

  const sendCondition = () => {
    const body = {
      ...pipeCondition,
      idUnit: data.id,
      percentage: percentage
    }
    if(pipeCondition?.id) dispatch(putPipeConditionUnit(body))
    else dispatch(postPipeConditionUnit(body));
    setTimeout(() => {
      onClose()
    }, 400);
  }

  useEffect(() => {
    if(pipeCondition?.id) setPercentage(pipeCondition?.percentage)
  }, [pipeCondition])

  return (
    <Box style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '10rem' }}>
      <TextField type="number" label="Porcentaje" name="percentage" value={percentage} onChange={handlePercentage} variant="outlined" />
      <Box style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 8 }}>
        <RegularButton color="success" onClick={sendCondition}>Guardar</RegularButton>
        <RegularButton color="danger" onClick={onClose}>Cancelar</RegularButton>
      </Box>
    </Box>
  )
}
